<template>
  <section class="listing">
    <div class="header">
      <div class="title">Produtores</div>
      <button @click="$router.push('/producer/new')" class="button-new"><i class="fas fa-plus"></i><span>NOVO</span></button>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div v-for="p in producers" :key="p.id" class="list">
          <div class="data">
            <div class="main-data">{{ p.name }}</div>
            <div class="detail-data">{{ p.login }}</div>
          </div>
          <div class="actions">
            <button @click="$router.push(`/producer/${p.user}`)" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
          </div>
        </div>
      </div>
    </transition>
    <Producer v-if="producer" :id="producer" :producerData="producerData" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getByBusiness } from '../api/producer'
import Producer from './Producer.vue'

export default {
  name: 'producers',
  components: { Producer },
  props: ['id'],
  data () {
    return {
      loading: true,
      producer: null,
      producers: [],
      producerData: null
    }
  },
  watch: {
    async '$route' (value) {
      this.producer = value.params['id'] || null
      // Update list
      if (!value.params['id']) {
        try {
          this.loading = true
          this.producers = await getByBusiness()
          this.loading = false
        } catch (error) {
          logger.error(error, this)
        }
      } else {
        this.producerData = this.producers.find(x => x.user === Number(value.params['id']))
      }
    }
  },
  async mounted () {
    try {
      this.producer = this.id || null
      this.producers = await getByBusiness()
      this.loading = false
    } catch (error) {
      logger.error(error, this)
    }
  }
}
</script>
